<template>
    <div>
        <app-erros-box
            :erros="['CONTRATAÇÃO INDISPONÍVEL']"
            v-if="!contratacao"
        ></app-erros-box>
        <app-contratacao-detalhar
            :contratacao="contratacao"
            :movimentosServicos="movimentosServicos"
            :contratacoesServicos="contratacoesServicos"
            @obterAtualizacao="$emit('obterAtualizacao')"
            v-if="contratacao"
        >
            <template slot="footer">
                <div class="d-flex flex-row">
                    <btn-gestor-designado
                        class="mr-2"
                        v-if="perfilGerente && contratacao.ehGerContratacao"
                        :contratacao="contratacao"
                        :contratacoesServicos="contratacoesServicos"
                        @obterAtualizacao="$emit('obterAtualizacao')"
                    ></btn-gestor-designado>
                    <slot name="contratacaoFooter"></slot>
                    <btn-nova-solicitacao-aditivo
                        class="ml-2"
                        v-if="
                            perfilGestor && $temAcessoView('CRED-GEST-ADIT-01')
                        "
                        :contratacao="contratacao"
                        :contratacoesServicos="contratacoesServicos"
                        @obterAtualizacao="$emit('obterAtualizacao')"
                    ></btn-nova-solicitacao-aditivo>
                    <chk-nao-aditivar-contrato
                        class="ml-2"
                        v-if="
                            perfilGestor &&
                                $temAcessoView('CRED-GEST-CONT-02') &&
                                contratacao.permiteAditivar &&
                                !contratacao.temSolicitacaoAditivoPendente
                        "
                        :contratacao="contratacao"
                        @naoAditivarContratacao="naoAditivarContratacao()"
                    ></chk-nao-aditivar-contrato>
                    <btn-entraga-manual
                        :contratacao="contratacao"
                        :contratacoesServicos="contratacoesServicos"
                        @obterAtualizacao="$emit('obterAtualizacao')"
                    ></btn-entraga-manual>
                    <b-button
                        variant="primary"
                        class="ml-2"
                        @click.stop="mostrarAnexos = true"
                        v-if="
                            $temAcessoView('CRED-CONT-ANX-00') && !mostrarAnexos
                        "
                        ><i class="fa fa-paperclip"></i> Anexos
                    </b-button>
                </div>
            </template>
        </app-contratacao-detalhar>
        <contratacao-anexos
            v-if="$temAcessoView('CRED-CONT-ANX-00') && mostrarAnexos"
            :contratacao="contratacao"
            @fechar="mostrarAnexos = false"
        ></contratacao-anexos>
        <app-entregas
            :contratacao="contratacao"
            :entregas="entregas"
            :contratacoesServicos="contratacoesServicos"
            :movimentosServicos="movimentosServicos"
            @obterAtualizacao="$emit('obterAtualizacao')"
            v-if="contratacao"
        >
            <template slot="entregaAcoes" slot-scope="data">
                <slot name="entregaAcoes" v-bind="data"></slot>
            </template>
        </app-entregas>
    </div>
</template>

<script>
import ContratacaoDetalhar from './ContratacaoDetalhar'
import Entregas from './../entregas/Entregas'
import BtnGestorDesignado from './BtnGestorDesignado'
import ChkNaoAditivarContrato from './ChkNaoAditivarContrato'
import BtnNovaSolicitacaoAditivo from '../solicitacoesAditivos/BtnNovaSolicitacaoAditivo'
import BtnEntragaManual from './BtnEntragaManual'
import ContratacaoAnexos from './ContratacaoAnexos'

export default {
    props: {
        contratacao: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        },

        contratacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarAnexos: false
        }
    },

    methods: {
        naoAditivarContratacao() {
            this.$store.dispatch('addRequest')
            this.contratacoesServicos
                .naoAditivarContratacao(this.contratacao.codContratacao)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$emit('obterAtualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar contratação!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        entregas() {
            if (
                this.contratacao.entregasConsultoria &&
                this.contratacao.entregasInstrutoria
            ) {
                return this.contratacao.entregasConsultoria.concat(
                    this.contratacao.entregasInstrutoria
                )
            } else {
                return []
            }
        },

        perfilGerente() {
            return this.$route.name == 'Gerentes_Contratacoes_Detalhar'
        },

        perfilGestor() {
            return this.$route.name == 'Gestores_Contratacoes_Detalhar'
        }
    },

    created() {},

    components: {
        AppContratacaoDetalhar: ContratacaoDetalhar,
        AppEntregas: Entregas,
        BtnGestorDesignado,
        ChkNaoAditivarContrato,
        BtnNovaSolicitacaoAditivo,
        BtnEntragaManual,
        ContratacaoAnexos
    }
}
</script>
